import MyAccountMyBTPage from "@routes/MyAccount/components/MyAccountMyBTPage/MyAccountMyBTPage";
import MyAccountReadingHistoryPage from "@routes/MyAccount/components/MyAccountReadingHistoryPage/MyAccountReadingHistoryPage";
import {
  MyAccountActiveProps,
  MyAccountTabsEnum,
} from "@routes/MyAccount/utils/types";

/**
 * My Account Active Page Component
 * Figma:
 * https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3611-20234&t=XsTPoO6b0V5zVeJ1-4
 * https://www.figma.com/design/soi1ZhMqZHbss6tJLvLgaa/MY-ACCOUNT--WEB-?node-id=3707-35158&t=XsTPoO6b0V5zVeJ1-4
 */
export default function MyAccountActivePage({
  activeTab,
}: MyAccountActiveProps): React.ReactElement {
  if (activeTab === MyAccountTabsEnum.myBT) return <MyAccountMyBTPage />;

  if (activeTab === MyAccountTabsEnum.recent)
    return <MyAccountReadingHistoryPage />;

  return <></>;
}
